import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=263d25a1&scoped=true&"
import script from "./ToDo.vue?vue&type=script&lang=js&"
export * from "./ToDo.vue?vue&type=script&lang=js&"
import style0 from "./ToDo.vue?vue&type=style&index=0&id=263d25a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d25a1",
  null
  
)

export default component.exports